"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'ContractFollowInfo',
  components: {
    CommonUpload: _commonUpload.default,
    UserSelect: _multiUserSelect.default
  },
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      followList: [],
      showFollowDialog: false,
      isEditMode: false,
      followAttachments: [],
      showUserSelect: false,
      currentSelectType: '',
      followUserList: [],
      followUserName: '',
      followUserNickName: '',
      currentEditFollow: null,
      followForm: {
        content: '',
        type: '',
        remark: '',
        callDuration: '',
        step: '',
        image: ''
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['imgPreviewPrefix', 'filePreviewPrefix'])),
  mounted: function mounted() {
    this.initFollowList();
  },
  watch: {
    contract: {
      handler: function handler(newVal) {
        if (newVal) {
          this.initFollowList();
        }
      },
      deep: true
    }
  },
  methods: {
    // 初始化跟进列表
    initFollowList: function initFollowList() {
      var _this = this;

      if (this.contract.id) {
        // 构建请求参数
        var params = {
          contractId: this.contract.id,
          sort: 'createTime,DESC'
        }; // 调用获取合同跟进记录的接口

        (0, _cmsWorkOrder.getContractFollowList)(params).then(function (response) {
          if (response.code === 200) {
            // 处理返回的跟进记录数据
            _this.followList = response.data.map(function (item) {
              return {
                id: item.rowId,
                content: item.followContent,
                type: item.followType,
                createBy: item.createUserName,
                createTime: item.createTime,
                remark: item.remark,
                callDuration: item.callDuration,
                step: item.step,
                image: item.image,
                file: item.file
              };
            });
          } else {
            _this.$message.error(response.msg || '获取跟进记录失败');

            _this.followList = [];
          }
        }).catch(function (error) {
          console.error('获取跟进记录失败:', error);

          _this.$message.error('网络错误，请重试');

          _this.followList = [];
        });
      }
    },
    // 处理附件上传成功
    handleFollowFileUpload: function handleFollowFileUpload(files) {
      // 上传成功后不需要自动添加到 followAttachments 数组
      // 保持 followAttachments 数组只包含已保存的文件
      this.$message.success('附件上传成功');
    },
    // 处理附件删除成功
    handleFollowFileDelete: function handleFollowFileDelete(files) {// 删除成功后不需要处理 followAttachments 数组
      // 保持 followAttachments 数组只包含已保存的文件
    },
    // 打开用户选择
    onUserSelect: function onUserSelect(type) {
      this.currentSelectType = type;
      this.showUserSelect = true;
      this.$refs.userSelect.selectType = type; // 根据选择类型设置不同的已选用户

      var selectedUsers = [];
      var selectedUserNames = [];

      if (type === '跟进人') {
        selectedUsers = Array.isArray(this.followUserNickName) ? this.followUserNickName : this.followUserNickName ? [this.followUserNickName] : [];
        selectedUserNames = Array.isArray(this.followUserName) ? this.followUserName : this.followUserName ? [this.followUserName] : [];
      }

      this.$refs.userSelect.nickNames = selectedUsers;
      this.$refs.userSelect.userNames = selectedUserNames;
      this.$refs.userSelect.isFirst = false;
      this.$refs.userSelect.getDeptDatas("爱阁工房");
    },
    // 关闭用户选择
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
      this.currentSelectType = '';
    },
    // 选择用户回调
    selectUserCallBack: function selectUserCallBack(user) {
      if (this.currentSelectType === '跟进人') {
        this.followUserList = user.nickNames;
        this.followUserName = user.userNames;
        this.followUserNickName = user.nickNames;
      }

      this.showUserSelect = false;
      this.currentSelectType = '';
    },
    // 打开添加跟进记录弹窗
    openAddFollowDialog: function openAddFollowDialog() {
      // 重置表单数据
      this.isEditMode = false;
      this.currentEditFollow = null;
      this.followForm = {
        content: '',
        type: '',
        remark: '',
        callDuration: '',
        step: '',
        image: ''
      };
      this.followAttachments = [];
      this.followUserList = [];
      this.followUserName = '';
      this.followUserNickName = ''; // 清空附件上传组件的文件列表

      if (this.$refs.followFileUpload) {
        this.$refs.followFileUpload.clearImgs();
      } // 打开弹窗


      this.showFollowDialog = true;
    },
    // 打开编辑跟进记录弹窗
    openEditFollowDialog: function openEditFollowDialog(follow) {
      var _this2 = this;

      // 保存当前编辑的跟进记录
      this.isEditMode = true;
      this.currentEditFollow = follow; // 填充编辑表单数据

      this.followForm = {
        content: follow.content,
        type: follow.type,
        remark: follow.remark,
        callDuration: follow.callDuration,
        step: follow.step,
        image: follow.image
      }; // 处理跟进人数据

      this.followUserList = [follow.createBy];
      this.followUserNickName = [follow.createBy]; // 清空上传组件的文件列表

      if (this.$refs.followFileUpload) {
        this.$refs.followFileUpload.clearImgs();
      } // 处理附件数据


      this.followAttachments = [];

      if (follow.file) {
        try {
          var files = typeof follow.file === 'string' ? JSON.parse(follow.file) : follow.file;

          if (Array.isArray(files)) {
            this.followAttachments = files.map(function (file) {
              // 确保每个文件对象都有type属性
              if (!file.type) {
                // 根据文件名判断文件类型
                var fileName = file.realName || file.name;

                if (fileName) {
                  var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
                  var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                  file.type = imgExtensions.includes(fileExtension.toLowerCase()) ? '图片' : '文件';
                } else {
                  file.type = '文件';
                }
              } // 确保每个文件对象都有url属性


              if (!file.url) {
                if (file.type === '图片') {
                  file.url = _this2.imgPreviewPrefix + (file.realName || file.name);
                } else {
                  file.url = _this2.filePreviewPrefix + (file.realName || file.name);
                }
              }

              return file;
            });
          }
        } catch (error) {
          console.error('解析附件数据失败:', error);
        }
      } // 打开弹窗


      this.showFollowDialog = true;
    },
    // 保存跟进记录
    saveFollow: function saveFollow() {
      var _this3 = this;

      if (!this.followForm.content) {
        this.$message.error('跟进内容不能为空');
        return;
      } // 合并 followAttachments 中的文件与新上传的文件


      var uploadedFiles = []; // 首先添加 followAttachments 中的文件（已删除的文件不会在这个数组中）

      if (this.followAttachments && this.followAttachments.length > 0) {
        this.followAttachments.forEach(function (file) {
          uploadedFiles.push(file);
        });
      } // 然后添加新上传的文件


      if (this.$refs.followFileUpload && this.$refs.followFileUpload.filePaths) {
        this.$refs.followFileUpload.filePaths.forEach(function (fileStr) {
          try {
            var fileObj = JSON.parse(fileStr); // 检查是否已存在相同的文件，避免重复添加

            var isDuplicate = uploadedFiles.some(function (existingFile) {
              return existingFile.realName === fileObj.realName;
            });

            if (!isDuplicate) {
              uploadedFiles.push(fileObj);
            }
          } catch (error) {
            console.error('解析文件数据失败:', error);
          }
        });
      } // 构建请求参数


      var params = {
        contractId: this.contract.id,
        followName: this.followUserNickName && this.followUserNickName.length > 0 ? this.followUserNickName.join(', ') : this.$store.getters.userInfo && this.$store.getters.userInfo.name ? this.$store.getters.userInfo.name : '',
        followContent: this.followForm.content,
        followType: this.followForm.type,
        callDuration: this.followForm.callDuration,
        step: this.followForm.step,
        file: uploadedFiles.length > 0 ? JSON.stringify(uploadedFiles) : '',
        remark: this.followForm.remark
      }; // 根据模式决定调用哪个接口

      var apiCall;

      if (this.isEditMode) {
        if (!this.currentEditFollow) {
          this.$message.error('编辑对象不存在');
          return;
        } // 添加编辑所需的参数


        params.rowId = this.currentEditFollow.id;
        params.followTime = this.currentEditFollow.createTime;
        apiCall = (0, _cmsWorkOrder.updateContractFollow)(params);
      } else {
        // 添加创建所需的参数
        params.followTime = new Date().toISOString();
        apiCall = (0, _cmsWorkOrder.addContractFollow)(params);
      } // 调用接口


      apiCall.then(function (response) {
        if (response.code === 200) {
          _this3.$message.success(_this3.isEditMode ? '更新跟进记录成功' : '添加跟进记录成功');

          _this3.showFollowDialog = false; // 重置表单数据

          _this3.followForm = {
            content: '',
            type: '',
            remark: '',
            callDuration: '',
            step: '',
            image: ''
          }; // 清空followAttachments数组，因为它只用于显示已保存的文件

          _this3.followAttachments = [];
          _this3.followUserList = [];
          _this3.followUserName = '';
          _this3.followUserNickName = '';
          _this3.currentEditFollow = null; // 清空附件上传组件的文件列表

          if (_this3.$refs.followFileUpload) {
            _this3.$refs.followFileUpload.clearImgs();
          } // 重新加载跟进列表


          _this3.initFollowList(); // 触发事件通知父组件重新查询客户数据


          _this3.$emit('refresh-customer-data');
        } else {
          _this3.$message.error(response.msg || (_this3.isEditMode ? '更新跟进记录失败' : '添加跟进记录失败'));
        }
      }).catch(function (error) {
        console.error(_this3.isEditMode ? '更新跟进记录失败:' : '添加跟进记录失败:', error);

        _this3.$message.error('网络错误，请重试');
      });
    },
    // 解析跟进记录中的附件数据
    parseFollowFile: function parseFollowFile(fileData) {
      try {
        if (typeof fileData === 'string') {
          var files = JSON.parse(fileData);
          return this.processFiles(files);
        } else if (Array.isArray(fileData)) {
          return this.processFiles(fileData);
        }
      } catch (error) {
        console.error('解析附件数据失败:', error);
      }

      return [];
    },
    // 处理文件数据，添加完整的URL
    processFiles: function processFiles(files) {
      var _this4 = this;

      return files.map(function (file) {
        var url = file.url;

        if (!url) {
          if (file.type === '图片') {
            url = _this4.imgPreviewPrefix + file.realName;
          } else {
            url = _this4.filePreviewPrefix + file.realName;
          }
        }

        return _objectSpread(_objectSpread({}, file), {}, {
          url: url
        });
      });
    },
    // 下载文件
    downloadFile: function downloadFile(url) {
      if (!url) return;
      fetch(url, {
        mode: 'cors'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = url.substring(url.lastIndexOf('/') + 1) || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        window.open(url, '_blank');
      });
    },
    // 删除跟进附件
    delFollowAttachmentByIndex: function delFollowAttachmentByIndex(index) {
      if (this.followAttachments && this.followAttachments.length > index) {
        // 从 followAttachments 数组中删除附件
        this.followAttachments.splice(index, 1); // 不要更新 CommonUpload 组件的 fileList 和 filePaths，避免删除的附件出现在上方上传组件中
      }
    }
  }
};
exports.default = _default2;